import { useContext, useMemo } from 'react'
import { useSKUs } from '@/hooks/useSKUs'

import { SKURow, SKURowSkeleton } from './components'
import { SkuListContext } from './contexts'

export function SkuList() {
  const { isExpanded, product } = useContext(SkuListContext)
  const { data: skus = [], isLoading } = useSKUs(product.id, isExpanded)

  const totalSkusArray = useMemo(
    () => new Array(product.totalSku).fill(''),
    [product]
  )

  if (!isExpanded) return null

  if (isLoading) {
    return (
      <>
        {totalSkusArray.map((_, idx) => (
          <SKURowSkeleton key={idx} />
        ))}
      </>
    )
  }

  return (
    <>
      {skus.map((sku) => (
        <SKURow key={sku.id} sku={sku} product={product} />
      ))}
    </>
  )
}
